<div style="width:600px;">
  <div style="width:99%;">
 <span> <button class="btn btn border" (click)="saveConnection()" [disabled]="!form.dirty">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
 <br><hr />
<form [formGroup]="form">

<div class="row">
<div class="col-md-8">
    <label>
      Behörighetsroll
    </label>

    <p-select *ngIf="roles.length > 0" appendTo="body" [options]="roles" formControlName="roleId" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setRole($event)"></p-select>

  </div>
</div>
  </form>
  </div>
</div>


